import { Stack } from '@mantine/core';
import { BasicFieldInputs } from '../components/BasicFieldInputs';

export const SignatureField = ({
  field,
  setField,
}: {
  field: any;
  setField: (field: any) => void;
}) => {
  return (
    <Stack gap="md">
      <BasicFieldInputs
        fields={['label']}
        fieldValues={field}
        requiredFields={['label']}
        onChange={(key, value) => setField({ ...field, [key]: value })}
      />
    </Stack>
  );
};
